<style lang="stylus">
    .expand-drop{
        position: absolute;
    }
    .expand-drop > div{
        background-color: var(--bg-color-menu-container);
        border: 0.5px solid var(--border-color-box-4);
        box-shadow: var(--box-shadow-color-expand-drop);
        border-radius: 8px;
        padding: 6px;
    }
</style>

<template>
    <div class="expand-drop" v-show="showExpand" :style="{ top: expandDropTop + 'px', left: mainWidth + 'px' }" @mouseleave="closeExpand">
        <keep-alive>
            <component :is="activedExpandDrops" :from="'topDrop'" @closeDrop="closeDrop"></component>
        </keep-alive>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";

    // () => import('')
    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            ImportMenu: () => import("./expandMenus/ImportMenus.vue"),
            DownloadMenu: () => import("./expandMenus/DownloadMenus.vue"),
            AlignMenus: () => import("./expandMenus/AlignMenus.vue"),
            distributeMenus: () => import("./expandMenus/distributeMenus.vue"),
            matchSizeMenus: () => import("./expandMenus/matchSizeMenus.vue"),
            gridMenus: () => import("./expandMenus/gridMenus.vue"),
            guidesMenus: () => import("./expandMenus/guidesMenus.vue"),
            marginsMenus: () => import("./expandMenus/marginsMenus.vue"),
            languageMenus: () => import("./expandMenus/languageMenus.vue"),
            CryptMenus: () => import("./expandMenus/CryptMenus.vue"),
            LockExpand: () => import("./expandMenus/LockExpand.vue"),
            ToolBar: () => import("./expandMenus/ToolBar.vue"),
            optGuides: () => import("./expandMenus/operationsMenus.vue"),
            selectLayerMenus: () => import("./expandMenus/selectLayerMenus.vue"),
            selectShapesMenus: () => import("./expandMenus/selectShapesMenus.vue"),
            selectLinesMenus: () => import("./expandMenus/selectLinesMenus.vue"),
            excludeSelMenus: () => import("./expandMenus/excludeSelMenus.vue"),
            saveasMenus: () => import("./expandMenus/saveasMenus.vue"),
            AIMore: () => import("./expandMenus/AIMore.vue"),
            AIFlow: () => import("@/app/components/Common/Context/expandMenus/AiFlow.vue"),
            AIChart: () => import("./expandMenus/AIChart.vue"),
            AIGantt: () => import("./expandMenus/AIGantt.vue"),
            AIOrg: () => import("./expandMenus/AIOrg.vue"),
        },
    })
    export default class ExpandDrops extends Vue {
        @Prop({ default: 0 }) mainWidth: number; // 一级组件宽度

        expandDropType: string = "";
        expandDropTop: number = 0;

        closeExpand() {
            this.expandDropType = "";
        }
        closeDrop() {
            this.$emit("closeDrop");
        }
        get showExpand() {
            return this.$store.state.ui.showDropExpand;
        }
        set showExpand(v: boolean) {
            this.$store.commit("setStatus", {
                type: "showDropExpand",
                data: v,
            });
        }
        get isActived() {
            return this.$store.state.shape.isActived;
        }
        get isActiveShape() {
            return (
                this.isActived &&
                !this.$store.state.shape.isLine &&
                !this.$store.state.shape.isAllMMShape &&
                !this.$store.state.shape.isIgnJump &&
                !(this.$store.state.shape.type === "Image") &&
                !this.$store.state.shape.isMultiSel &&
                !(this.$store.state.shape.type === "Group")
            );
        }
        get isActiveLine() {
            return this.$store.state.shape.isActived && this.$store.state.shape.type === "ConnectLine" && !this.$store.state.shape.isMultiSel;
        }
        get isSelect() {
            return this.$store.state.shape.isActived;
        }
        get isMultiSel() {
            return this.$store.state.shape.isMultiSel;
        }
        get multiSelCount() {
            return this.$store.state.shape.multiSelCount;
        }
        get shapeType() {
            return this.$store.state.shape.type;
        }
        get flowAnalyse() {
            return this.$store.state.shape.flowAnalyse;
        }
        get activedExpandDrops() {
            if (this.expandDropType === "Import") {
                return "ImportMenu";
            } else if (this.expandDropType === "Download") {
                return "DownloadMenu";
            } else if (this.expandDropType === "align" && this.isMultiSel) {
                return "AlignMenus";
            } else if (this.expandDropType === "distribute" && this.isMultiSel && this.multiSelCount > 2) {
                return "distributeMenus";
            } else if (this.expandDropType === "matchSize" && this.isMultiSel) {
                return "matchSizeMenus";
            } else if (this.expandDropType === "grid") {
                return "gridMenus";
            } else if (this.expandDropType === "guides") {
                return "guidesMenus";
            } else if (this.expandDropType === "margins") {
                return "marginsMenus";
            } else if (this.expandDropType === "language") {
                return "languageMenus";
            } else if (this.expandDropType === "lockExpand" && this.isSelect) {
                return "LockExpand";
            } else if (this.expandDropType === "toolbars") {
                return "ToolBar";
            } else if (this.expandDropType === "optGuides") {
                return "optGuides";
            } else if (this.expandDropType === "Crypt") {
                return "CryptMenus";
            } else if (this.expandDropType === "selectLayer") {
                return "selectLayerMenus";
            } else if (this.expandDropType === "selectShapes" && this.isActiveShape) {
                return "selectShapesMenus";
            } else if (this.expandDropType === "selectLines" && this.isActiveLine) {
                return "selectLinesMenus";
            } else if (this.expandDropType === "excludeSel" && this.isMultiSel) {
                return "excludeSelMenus";
            } else if (this.expandDropType === "SaveAs") {
                this.$bus.$emit("changeCustomTList");
                return "saveasMenus";
            } else if (this.expandDropType === "AIMore") {
                return "AIMore";
            } else if (this.expandDropType === "flow_analysis" && this.flowAnalyse) {
                return "AIFlow";
            } else if (this.expandDropType === "chart_analysis" && this.shapeType == "EDChart") {
                return "AIChart";
            } else if (this.expandDropType === "table_analysis" && this.shapeType == "Table") {
                return "AIChart";
            } else if (this.expandDropType === "gantt_analysis" && this.shapeType == "Gantt") {
                return "AIGantt";
            } else if (this.expandDropType === "orgchart_analysis" && this.shapeType == "OrgShape") {
                return "AIOrg";
            } else {
                return null;
            }
        }

        mounted() {}

        created() {
            let ts: any = this;
            ts.$bus.$on("changeDropType", (type: string, top: number) => {
                this.expandDropTop = top;
                console.log("type", type);
                if (type === "toolbars") {
                    this.expandDropTop -= 200;
                }
                if (type === "AIMore") {
                    this.expandDropTop -= 188;
                }
                this.expandDropType = type;
            });
        }
        beforeDestroy() {
            let ts: any = this;
            ts.$bus.$off("changeDropType");
        }
    }
</script>
